import { render } from "./form4.vue?vue&type=template&id=1cf66679&scoped=true"
import script from "./form4.vue?vue&type=script&lang=js"
export * from "./form4.vue?vue&type=script&lang=js"

import "./form4.vue?vue&type=style&index=0&id=1cf66679&lang=less&scoped=true"

import exportComponent from "/Users/a/k618/work/sxdsjtj/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cf66679"]])

export default __exports__